import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '@iso/lib/helpers/rtl';
// import Graphik from './fonts/GRAPHIK-REGULAR.TTF';
import Graphik from './fonts/GraphikLCG-Regular.ttf';
import Lava from './fonts/LAVAPRO-BOLD.TTF';
import Almarai from './fonts/Almarai-Regular.ttf';
import Barriecito from './fonts/Barriecito-Regular.ttf';

const LocalEatzWrapper = styled.div`
  margin: auto;
  max-width: 1200px;

  // @media screen and (min-width: 1200px) and (max-width: 1500px) {
  //   max-width: 1150px;
  // }

  @font-face {
    font-family: 'Graphik';
    src: url('${Graphik}');
  }
  @font-face {
    font-family: 'Graphik LCG';
    src: url('${Graphik}');
  }
  @font-face {
    font-family: 'Lava Pro';
    src: url('${Lava}');
  }
  @font-face {
    font-family: 'Almarai';
    src: url('${Almarai}');
  }
  @font-face {
    font-family: 'Barriecito';
    src: url('${Barriecito}');
  }

  .form-select:focus {
    border-color: inherit;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  a {
    text-decoration: none;
  }

  .custom-container {
    padding: 0 24px;
  }

  .homepage-header {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    color: #ffffff;
    height: 350px;
    border-radius: 0 0 30px 30px;
    overflow: hidden;
  }

  .language-selector-block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px;
  }

  .language-selector-block-pizzabox {
    display: flex;
    justify-content: end;
    align-items: center;
    margin: 10px;
  }

  .header-top {
    display: flex;
    justify-content: center;
    align-items: center;
    // max-height: 240px;
  }

  .homepage-header .homepage-header-content {
    font-family: 'Almarai', serif;
    font-style: normal;
    font-size: 25px;
    line-height: 26px;
    padding-left: 24px;
    margin-top: 15px;
    padding-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    img {
      max-height: 140px;
      margin-bottom: 6px;
    }
    .homepage-header-icon {
      height: 100%;
    }

    @media only screen and (max-width: 767px) {
      .homepage-header-icon {
        width: 365px;
      }
    }
  }

  .homepage-header .homepage-header-content-pizzabox {
    font-family: 'Almarai', serif !important;
    font-style: normal;
    font-size: 25px;
    line-height: 26px;
    padding-left: 24px;
    margin-top: 15px;
    padding-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    img {
      max-height: 55px;
      margin-bottom: 6px;
    }
    .homepage-header-icon-pizzabox {
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: #ff8700;
      padding: 5px 35px;
      border-radius: 0 0 20px 0;
    }
    @media only screen and (max-width: 767px) {
      .homepage-header-icon-pizzabox {
        // width: 365px;
      }
    }
  }

  .homepage-header-description {
    text-align: center;
    font-family: 'Almarai', serif;
    font-weight: 600;
    font-size: 50px;
    margin-bottom: 6px;
    line-height: 55px;

    span {
      font-style: normal;
    }
    @media only screen and (max-width: 767px) {
      font-size: 25px;
      line-height: 30px;
    }
  }

  .homepage-header-description-pizza {
    text-align: center;
    font-family: 'Barriecito', serif;
    font-weight: 600;
    font-size: 65px;
    margin-bottom: 6px;
    line-height: 55px;

    span {
      font-style: normal;
    }
    @media only screen and (max-width: 767px) {
      display: none;
      // &.homepage-header-description-pizza-mobile {
      //   display: none;
      // }
    }
  }

  .homepage-header-description-pizza-mobile {
    text-align: center;
    font-family: 'Barriecito', serif;
    font-weight: 600;
    margin-bottom: 6px;
    font-size: 33px;
    line-height: 42px;
    display: none;

    span {
      font-style: normal;
    }

    @media only screen and (max-width: 767px) {
      display: block;
    }
  }

  .homepage-header-pizza-name {
    margin-top: 28px;
    font-family: 'Barriecito', serif;
    font-size: 33px;
    font-weight: 600;

    @media only screen and (max-width: 767px) {
      font-size: 23px;
    }
  }

  #background-video {
    width: 100%;
    // max-width: 1200px;
    height: 350px;
    object-fit: cover;
    position: relative;
    object-position: center;
  }

  .header-content {
    position: absolute;
    width: 100%;
    // max-width: 1200px;
    max-height: 350px;
    height: 350px;
    overflow: hidden;
    top: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    background-color: #00000047;
    border-radius: 0 0 30px 30px;
  }

  .header-content-pizza {
    position: absolute;
    width: 100%;
    // max-width: 1200px;
    max-height: 350px;
    height: 350px;
    overflow: hidden;
    top: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    background-color: #00000047;
    border-radius: 0 0 30px 30px;
  }

  .homepage-search-block {
    width: 65%;
    padding-left: 40px;

    p {
      font-family: 'Lava Pro', serif;
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 32px;
      color: #0d092b;
      margin-bottom: 6px;
    }

    @media only screen and (max-width: 767px) {
      width: 100%;
    }
  }

  .homepage-search-block-variant-2 {
    margin-top: 30px;
    padding-left: 24px;
  }

  .promotions-slider {
    margin-top: 22px;
  }

  .promotions-slider .slick-slide {
    width: 325px;
    margin-left: 20px;
  }

  .promotions-slider .slick-current {
    padding-left: 24px;
  }

  .category-slider {
    margin-top: 20px;
  }

  .category-slider .slick-slider .slick-list .slick-track {
    margin-left: 24px;
  }

  .category-slider a {
    color: #0d092b;
  }

  .category-slider .slick-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 170px;
    height: 145px;
    margin-left: 16px;
    border-radius: 20px;
    cursor: pointer;
    transition: 0.4s;

    &:hover {
      filter: brightness(0.85);
    }
  }

  .category-slider .slick-slide:nth-child(7n + 1) {
    background: #edb37a;
    // background : url("@iso/assets/images/localeats/pizzaCategory/1.png");
  }

  .category-slider .slick-slide:nth-child(7n + 2) {
    background: #f6b351;
  }

  .category-slider .slick-slide:nth-child(7n + 3) {
    background: #eff3eb;
  }

  .category-slider .slick-slide:nth-child(7n + 4) {
    background: #f9f9fb;
  }

  .category-slider .slick-slide:nth-child(7n + 5) {
    background: #c3da75;
  }

  .category-slider .slick-slide:nth-child(7n + 6) {
    background: #f4eadc;
  }

  .category-slider .slick-slide:nth-child(7n + 7) {
    background: #eff3eb;
  }

  .category-slider .category-slider {
    font-family: 'Graphik', serif;
    font-weight: 500;
    font-size: 15px;
    line-height: 22px;
  }

  .category-slider-pizza {
    margin-top: 20px;
  }

  .category-slider-pizza .slick-slider .slick-list .slick-track {
    margin-left: 6px;
  }

  category-slider-pizza a {
    color: #0d092b;
  }

  .category-slider-pizza .slick-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 170px;
    height: 145px;
    // margin-left: 16px;
    border-radius: 20px;
    cursor: pointer;
    transition: 0.4s;

    &:hover {
      filter: brightness(0.85);
    }
  }

  // .category-slider-pizza .slick-slide:nth-child(7n + 1) {
  //   background: #edb37a;
  //   // background : url("@iso/assets/images/localeats/pizzaCategory/1.png");
  // }

  // .category-slider-pizza .slick-slide:nth-child(7n + 2) {
  //   background: #f6b351;
  // }

  // .category-slider-pizza .slick-slide:nth-child(7n + 3) {
  //   background: #eff3eb;
  // }

  // .category-slider-pizza .slick-slide:nth-child(7n + 4) {
  //   background: #f9f9fb;
  // }

  // .category-slider-pizza .slick-slide:nth-child(7n + 5) {
  //   background: #c3da75;
  // }

  // .category-slider-pizza .slick-slide:nth-child(7n + 6) {
  //   background: #f4eadc;
  // }

  // .category-slider-pizza .slick-slide:nth-child(7n + 7) {
  //   background: #eff3eb;
  // }

  .category-slider-pizza .category-slider-pizza {
    font-family: 'Graphik', serif;
    font-weight: 500;
    font-size: 15px;
    line-height: 22px;
  }

  .restaurant-item-controls {
    padding: 0 24px;
    margin-top: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .all-btn-container {
    // padding-right: 20px;
    @media only screen and (max-width: 767px) {
      padding-right: 10px;
    }
  }

  .all-btn-container .all-button {
    font-family: 'Graphik', serif;
    font-style: normal;
    min-width: 122px;
    background: #2a2b2c;
    border-radius: 13px;
    text-align: center;
    font-weight: 600;
    font-size: 13px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: white;
    padding: 13px 30px;
    transition: 0.3s;
    cursor: pointer;
  }
  .filter-button:hover {
    opacity: 0.85;
  }
  .filter-button img {
    margin-right: 8px;
    width: 20px;
  }

  .restaurant-item-controls .card-view-controls-block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px;
    background: #e9e9f5;
    border-radius: 13px;
    max-width: 200px;
    width: 100%;
    margin-left: 10px;
  }

  .restaurant-item-controls .card-view-controls-block .card-view-control-item {
    width: 33.333333%;
    padding: 6px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: 0.3s;
  }

  .restaurant-item-controls .card-view-controls-block .active {
    border-radius: 10px;
    background: #ffa24b;
  }

  .restaurant-item-controls .card-view-controls-block .active img {
    filter: brightness(0) invert(1);
  }

  .restaurant-item-controls
    .card-view-controls-block
    .card-view-control-item:hover {
    opacity: 0.8;
  }

  .restaurant-block {
    margin-top: 22px;
    padding-bottom: 5px;
  }

  .restaurant-block .restaurant-col {
    margin-bottom: 16px;
    padding: 0;
  }

  .restaurant-block .custom-container {
    padding: 0 18px;
    margin-bottom: 10px;
  }

  .about-modal .ant-modal-wrap .ant-modal .ant-modal-content {
    position: fixed;
  }

  @media screen and (min-width: 768px) and (max-width: 1200px) {
    margin: auto;
    max-width: 90%;
    .homepage-header .homepage-header-content .homepage-header-icon {
      max-width: 95%;
    }
    .homepage-header-description {
      font-size: 32px;
    }
  }

  @media screen and (min-width: 1201px) and (max-width: 1500px) {
    body {
      overflow-x: hidden; /* Prevent horizontal scrolling */
    }

    margin: auto;
    max-width: 1100px;
    .homepage-header {
      height: 349px;
    }
    // .homepage-header .homepage-header-content .homepage-header-icon {
    //   max-width: 95%;
    // }
    // .homepage-header-description {
    //   font-size: 40px;
    // }
  }
`;

export default WithDirection(LocalEatzWrapper);
